import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import * as configApi from '@/modules/bd-unificada/api/configApi'
import type {
  ConfiguracionUpdateInput,
  TestConnectionInput,
} from '@/modules/bd-unificada/types/configuracion'

export const configKeys = {
  all: ['bd-unificada', 'config'] as const,
}

export function useConfiguracion() {
  return useQuery({
    queryKey: configKeys.all,
    queryFn: () => configApi.getConfiguracion(),
  })
}

export function useGuardarConfiguracion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: ConfiguracionUpdateInput) => configApi.guardarConfiguracion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: configKeys.all })
      toast.success('Configuración guardada exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al guardar la configuración')
    },
  })
}

export function useTestConnection() {
  return useMutation({
    mutationFn: (data?: TestConnectionInput) => configApi.testConnection(data),
  })
}
